import { Tooltip } from 'antd'
import React from 'react'


const TagDart = (props) => {
  const { handleTagSearch, tagInfo, hash } = props
  const isTagSliced = (tagInfo && tagInfo.length > 15)
  const slicedTag = (isTagSliced) ? tagInfo.slice(0, 15) : tagInfo
  return (
    <React.Fragment>
      {!isTagSliced &&
        <a className="bb-archives-block__tags-item" onClick={() => handleTagSearch(tagInfo)} href={hash}>
          <p>{tagInfo}</p>
        </a>}

      {isTagSliced &&

        <a
          className="bb-archives-block__tags-item"
          onClick={() =>
            handleTagSearch(tagInfo)
          }
          href={hash}
        >
          <Tooltip title={tagInfo} placement="top">
            <p>
              {slicedTag + "..."}
            </p>
          </Tooltip>
        </a>

      }

    </React.Fragment>
  )


}

export default TagDart